export const APP_VERSION = process.env.VUE_APP_VERSION
export const APPS = 203
